<template>
  <div class="container news">
    <div class="d-flex news_box">
      <div class="col-2 d-flex news_title">
        <div>News</div>
        <div>最新消息</div>
      </div>
      <div class="col-10 d-flex news_message">
        <router-link :to="{ 'name': 'news_page', 'params': { id: item.id } }" class="d-flex news_message_box"
          v-for="item in news" :key="item.id">
          <div class="news_message_date d-flex col-2">
            {{ item.create_at.substr(0, 10) }}
          </div>
          <div class="news_message_text col-10" :title='item.title'>
            {{ item.title }}
          </div>
        </router-link>
        <div v-show="news.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
          <img src="../../assets/loading.gif">
        </div>
      </div>
    </div>
    <moreButton button_text="更多消息" button_href="news"></moreButton>
  </div>
</template>

<script>
import MoreButton from '@/components/index/MoreButton'
export default {
  name: 'news',
  props: {},
  components: {
    'moreButton': MoreButton,
  },
  data() {
    return {
      news: [
        // {
        //   create_at:"2018-11-14" ,
        //   title:"♡新北最大規模寶寶運動會 全新賽事登場♡11/30-12/3五股嬰兒與孕媽咪用品展",
        //   id:"https://www.top-link.com.tw/tlweb/news/info/83?page=1",
        // },
        // {
        //   create_at:"2018-10-22" ,
        //   title:"★年終大回饋★11/30-12/3新北最大規模婦幼品牌特賣會【免費索票】尿布/奶瓶/推車全面3折起！",
        //   id:"https://www.top-link.com.tw/tlweb/news/info/81?page=1",
        // },
        // {
        //   create_at:"2018-10-17" ,
        //   title:"【10/14-17台北嬰兒與孕媽咪用品展 展後加碼抽-情報誌封面抽獎&回娘家邀卡&幸福御守&雙人招待票】抽獎名單出爐拉~",
        //   id:"https://www.top-link.com.tw/tlweb/news/info/80?page=1",
        // },
        // {
        //   create_at:"2018-09-05" ,
        //   title:"【8/31-9/3台中嬰兒與孕媽咪用品展 展後加碼抽10大好禮&情報誌封面抽獎】抽獎名單出爐拉~",
        //   id:"https://www.top-link.com.tw/tlweb/news/info/77?page=1",
        // },
        // {
        //   create_at:"2018-09-05" ,
        //   title:"【8/31-9/3台北3C電腦電器空調影音展】消費滿額抽_得獎名單 出爐囉！",
        //   id:"https://www.top-link.com.tw/tlweb/news/info/76?page=2",
        // },
        // {
        //   create_at:"2018-09-05" ,
        //   title:"【8/31-9/3台北3C電腦電器空調影音展】消費滿額抽_得獎名單 543！",
        //   id:"https://www.top-link.com.tw/tlweb/news/info/76?page=2",
        // },
      ]
    }
  },
  computed: {
  },
  created() {
    var news = this;
    var news_api = process.env.VUE_APP_API + 'tlweb/news?online=1&rows=5'
    this.axios.get(news_api)
      .then(function (response) {
        news.news = response.data.data.data.filter(function (item, index) {
          return index < 5;
        });
        // console.log("news", news.news)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
}
</script>

<style>
.news .news_box {
  margin: 40px 0;
}

.news .news_title {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.news .news_title div:first-child {
  color: #00a0e9;
  font-size: 25px;
  margin-bottom: 5px;
}

.news .news_message {
  flex-direction: column
}

.news .news_message_date {
  margin: 10px 0;
  align-items: center;
  width: 88px;
}

.news .news_message_text {
  margin: 10px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.news .news_message_box {
  text-decoration: none;
  color: black;
  display: block;
}

.news .news_message_box:hover {
  color: #00a0e9;
}

@media(max-width: 768px) {
  .news .news_box {
    flex-direction: column;
    margin: 15px 0 30px;
  }

  .news .news_title {
    max-width: 100%;
  }

  .news .news_message {
    max-width: 100%;
    padding: 0;
  }

  .news .news_message_date {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }

  .news .news_message_text {
    max-width: 100%;
    padding: 0;
    margin-top: 0;
  }

  .news .news_message_box {
    flex-direction: column;
  }
}
</style>
